export default __webpack_public_path__ + "static/media/2022_yuletide.b70ab8e4.jpg";